@import '../../../../../style/lib/scss';
@import '../../../mixins/outline';

@mixin overlap-full {
	position: absolute;
	top: var(--zds-navigation-logo-overlap-offset-top);
	width: inherit;
	z-index: 1150;
}

:host {
	// Internal CSS variable
	--zds-navigation-logo-overlap-offset-top: var(--zds-space-1);
}

:host([overlap-behaviour='main-bar-only']) {
	align-self: stretch;
}

:host([position='top-left']) {
	--zds-navigation-logo-overlap-offset-top: 0px;

	margin-left: calc(-1 * var(--zds-navigation-main-bar-inset-x));
}

@include zds-media-breakpoint-up('lg') {
	:host([position='top-left']:not([overlap])) {
		margin-top: calc(-1 * var(--zds-navigation-main-bar-inset-y));
	}
}

@include zds-media-breakpoint-down('md') {
	:host([position='top-left']:not([overlap-mobile])) {
		margin-top: calc(-1 * var(--zds-navigation-main-bar-inset-y));
	}
}

.zds-navigation-logo {
	display: flex;
	max-width: 100%;

	&__wrapper,
	&__link {
		width: 100%;
	}

	&__link {
		@include outline;

		display: block;
	}

	&__img {
		display: block;
		max-width: 100%;
		transition: transform var(--zds-transition-sm);
		width: auto;

		&:hover {
			transform: scale(var(--zds-navigation-logo-scale-hover));
		}

		@include zds-media-breakpoint-up('md') {
			width: 100%;
		}

		@include zds-media-breakpoint-down('sm') {
			max-height: 50px;
		}
	}

	&--has-mobile-width &__img {
		@include zds-media-breakpoint-down('sm') {
			max-height: none;
		}
	}

	@include zds-media-breakpoint-up('md') {
		margin-right: var(--zds-space-6);
	}

	@include zds-media-breakpoint-up('lg') {
		&--overlap#{&}--overlap-behaviour-full &__wrapper {
			@include overlap-full;
		}

		&--overlap#{&}--overlap-behaviour-main-bar-only &__wrapper {
			margin-bottom: -100vh;
			margin-top: calc(var(--zds-navigation-logo-overlap-offset-top) - var(--zds-navigation-main-bar-inset-y));
		}
	}

	@include zds-media-breakpoint-down('md') {
		&--overlap-mobile &__wrapper {
			@include overlap-full;
		}
	}
}
